module.exports = __webpack_public_path__ + "img/ziyuan.7c71d8f1.png";